import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/pages/ProfileNotFoundPage.css';

const ProfileNotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="profile-not-found">
            <div className="profile-not-found__content">
                <h1>Profile Not Found</h1>
                <p>The profile you're trying to access doesn't exist.</p>

                <button
                    className="btn btn--primary btn--md"
                    onClick={() => navigate('/home')}
                >
                    Return Home
                </button>
            </div>
        </div>
    );
};

export default ProfileNotFound;